import { createSlice } from '@reduxjs/toolkit';

export interface DialogState {
  isOpen: boolean;
  content: {
    dialogTitle: string;
    dialogContentText: string;
    disagreeButtonText?: string;
    agreeButtonText: string;
  };
  result: boolean;
  handleClose: (state, action) => void;
}

const initialDialogState: DialogState = {
  isOpen: false,
  content: {
    dialogTitle: '',
    dialogContentText: '',
    agreeButtonText: '',
  },
  result: null,
  handleClose: null,
};

const DialogSlice = createSlice({
  name: 'Dialog',
  initialState: initialDialogState,
  reducers: {
    openDialog(state, action): void {
      state.isOpen = true;
      state.content = action.payload.content;
      state.handleClose = action.payload.handleClose;
    },
    closeDialog(state): void {
      state.isOpen = false;
    },
  },
});

export default DialogSlice.reducer;
export const dialogActions = DialogSlice.actions;
